module.exports = __webpack_public_path__ + "fonts/CircularStd-Medium.b5440221.woff";